module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Topbar'), _vm._v(" "), (!_vm.sent) ? _c('fieldset', {
    staticClass: "signin-form"
  }, [_c('legend', [_vm._v("Password reset")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.resetpw.apply(null, arguments)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "signin-email"
    }
  }, [_vm._v("E-Mail")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "full-width",
    attrs: {
      "type": "email",
      "id": "signin-email",
      "placeholder": "tom@aol.com",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button acc",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Reset Password")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n      Still remember your password?\n      "), _c('router-link', {
    attrs: {
      "to": {
        name: 'signin'
      }
    }
  }, [_vm._v("Sign in")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n      Have no account?\n      "), _c('router-link', {
    attrs: {
      "to": {
        name: 'signup'
      }
    }
  }, [_vm._v("Sign up")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.sent) ? _c('fieldset', {
    staticClass: "signin-form"
  }, [_c('legend', [_vm._v("Password reset")]), _vm._v(" "), _c('p', [_vm._v("\n      A password reset link has been sent to your E-Mail inbox.\n    ")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b4a267e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PWReset.vue
// module id = 293
// module chunks = 1